var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTlfLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 35,
    viewBox: "0 0 53 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 35L15 18H26V35Z",
    fill: "#00B2B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 17H0L26 0V17Z",
    fill: "#00B2B2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27 0L42.9142 24.5946L27 35L27 0Z",
    fill: "#00B2B2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7511 24.0473L53 18L39.8381 18L43.7511 24.0473Z",
    fill: "#00B2B2"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTlfLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/tlf-logo.97ddfcf3c3327883171e7919d32b752d.svg";